<mat-progress-bar mode="query" *ngIf="!reqLoaded"></mat-progress-bar>
<mat-list *ngIf="requests.length == 0">
    <mat-list-item>
        <span matListItemTitle
            >No Analysis has been requested for this bill.</span
        >
    </mat-list-item>
</mat-list>
<las-bill-request-item *ngFor="let request of requests" [request]="request"
    >Request Items</las-bill-request-item
>
